export const CHECK_COMPATIBILITY = 'checkCompatibility'
export const GET_CATALOG = 'getCatalog'
export const GET_CATALOG_BY_PRODUCTS = 'getCatalogByProducts'
export const GET_FARE_MEDIA_CATALOG = 'getFareMediaCatalog'
export const GET_FARE_MEDIAS = 'getFareMediaProducts'
export const GET_FINES = 'getFinesProducts'
export const GET_LIST_BY_PARAMETER_NAME = 'getListByParameterName'
export const GET_QUOTATIONS = 'getQuotations'
export const LOAD_PRODUCT_DETAILS = 'loadProductDetails'
